import React from 'react'

interface Props {
  value: string
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleBlur: (e: React.ChangeEvent<HTMLInputElement>) => void
  errors?: string
}

function JobLink({ value, handleBlur, handleChange, errors }: Props) {
  return (
    <div className="mb-4">
      <label
        className="block text-gray-700 text-sm font-bold mb-2"
        htmlFor="job-link"
      >
        Where to apply <span className={'mx-1 text-red-500'}>*</span>
      </label>
      {/* <div className="italic text-xs text-gray-700">
              Enter Job URL or email address
            </div> */}
      <input
        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
          errors && 'border-red-500'
        }`}
        id="job-link"
        type="text"
        placeholder="Enter Job URL or email address"
        name={'job_url'}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {errors && <p className="text-red-500 text-xs italic my-1">{errors}</p>}
    </div>
  )
}

export default JobLink
